const getCurrencySymbol = (str) => {
  switch (str.toLowerCase()) {
    case 'usd':
      return '$';
    case 'eur':
      return '€';
    case 'uah':
      return '₴';
    case 'gbp':
      return '£';
    case 'chf':
      return 'CHF';
    case 'aud':
      return 'AUD';
    default:
      return ' ';
  }
};

export default getCurrencySymbol;
